
'use strict';
var init = function (elm, options) {

	var $calendarButton = options.container.find('.ui-datepicker-trigger'),
		$calendarDateMsg =  options.container.find('.ui-datepicker-bottom-content'),
		currentDate = new Date();

	if (elm.hasClass('hasDatepicker')) {
		return;
	}

	function updateTextMessage() {
		if (!elm || $calendarDateMsg.find('p:first').length < 1) {
			return;
		}

		var selectedDate = elm.datepicker('getDate');
		if (selectedDate && selectedDate.getTime() <= currentDate.getTime()) {
			$calendarDateMsg.find('p:first').text('Send Now -');
		} else {
			$calendarDateMsg.find('p:first').text('Send Date');
		}
	}

	function initCloseButton() {
		if (!options.closeButtonNeeded) {
			return;
		}
		setTimeout(function() {
			var header = $(elm).datepicker('widget').find('.ui-datepicker-header');
			$('<button class="datepicker-close-btn">')
			.appendTo(header)
			.on('click', (function() {
				$(elm).datepicker('widget').hide();
			}));
		}, 1);
	}

	elm.datepicker('destroy');
	elm.datepicker({
		inline: true,
		showOtherMonths: true,
		selectOtherMonths: true,
		dayNamesMin: ['Sun', 'M', 'T', 'W', 'T', 'F', 'Sat'],
		dateFormat: 'dd/mm/yy',
		showAnim: 'blind',
		maxDate: (typeof options.maxDate === 'undefined' || options.maxDate === null) ? '+180d' : options.maxDate,
		minDate: (typeof options.minDate === 'undefined' || options.minDate === null) ? 0 : options.minDate,
		firstDay: 1,
		onSelect: function () {
			if ($calendarDateMsg.length > 0) {
				$calendarDateMsg.find('span:first').text(elm.val());
				$calendarDateMsg.show();
				updateTextMessage();
			}
			elm.trigger('change');
			elm.trigger('blur');
			$calendarButton.removeClass('active');
			// My subscription snooze save btn validation
			$('.snooze-subscription button').attr('disabled', false);
			// Resets select element
			$('.select-snooze-date').prop('selectedIndex', 0);
			if (options.callback) {
				options.callback();
			}
		},
		onClose: function (selectedDate, inst) {
			var enteredDate = new Date(inst.currentYear, inst.currentMonth, inst.currentDay);
			var dpDate = new Date(inst.selectedYear, inst.selectedMonth, inst.selectedDay);
			if (enteredDate !== dpDate) {
				elm.datepicker('setDate', dpDate);
			}
		},
		beforeShow: function () {
			if (options.calendarClass) {
				$('#ui-datepicker-div').addClass(options.calendarClass);
			}
			$('.ui-datepicker').attr('data-content', Resources.SEND_DATE_TXT);
			initCloseButton();
		},
		onChangeMonthYear: function () {
			initCloseButton();
		},
		beforeShowDay: function (el) {
			// handle subscription calendar conditions to show only first day of month or
			// first day of week for mbox products
			if (options.firstDayOnly === true) {
				if ((options.mbox && el.getDay() === 1) || el.getDate() === 1) {
					return [true];
				}
				return [false];
			}
			if (options.excludeSaturday === true && el.getDay() === 6) {
				return [false];
			}
			if (options.excludeSunday === true && el.getDay() === 0) {
				return [false];
			}
			if (options.excludedDaysOfWeek && options.excludedDaysOfWeek.indexOf(el.getDay() + 1) >= 0) {
				return [false];
			}
			if (options.excludedDates) {
				var dateString = $.datepicker.formatDate('yy-mm-dd', el);
				return [options.excludedDates.indexOf(dateString) === -1];
			} else {
				return [true];
			}
		}
	});

	elm.on('keyup', function() {
		elm.datepicker('show');
	});

	$calendarButton.on('click', function () {
		$(this).toggleClass('active');
		if ($(this).hasClass('active')) {
			elm.datepicker('show');
		} else {
			elm.datepicker('hide');
		}
	});
	updateTextMessage();
};



exports.init = init;
